var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99976 1.38062L17.4644 5.6903V14.3097L9.99976 18.6194L2.53516 14.3097V5.6903L9.99976 1.38062ZM3.3727 6.17386V12.505L8.85566 3.00828L3.3727 6.17386ZM9.99976 2.70172L3.67926 13.6491H16.3203L9.99976 2.70172ZM15.4827 14.4867H4.5168L9.99976 17.6523L15.4827 14.4867ZM16.6268 12.505L11.1439 3.00828L16.6268 6.17386V12.505Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99837 3.6281C10.9726 3.6281 11.7624 2.83833 11.7624 1.8641C11.7624 0.889867 10.9726 0.100098 9.99837 0.100098C9.02414 0.100098 8.23438 0.889867 8.23438 1.8641C8.23438 2.83833 9.02414 3.6281 9.99837 3.6281Z",
    fill: "#495057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0452 7.69621C18.0195 7.69621 18.8092 6.90644 18.8092 5.93221C18.8092 4.95798 18.0195 4.16821 17.0452 4.16821C16.071 4.16821 15.2812 4.95798 15.2812 5.93221C15.2812 6.90644 16.071 7.69621 17.0452 7.69621Z",
    fill: "#495057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0452 15.832C18.0195 15.832 18.8092 15.0422 18.8092 14.068C18.8092 13.0937 18.0195 12.304 17.0452 12.304C16.071 12.304 15.2812 13.0937 15.2812 14.068C15.2812 15.0422 16.071 15.832 17.0452 15.832Z",
    fill: "#495057"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99837 19.8998C10.9726 19.8998 11.7624 19.1101 11.7624 18.1358C11.7624 17.1616 10.9726 16.3718 9.99837 16.3718C9.02414 16.3718 8.23438 17.1616 8.23438 18.1358C8.23438 19.1101 9.02414 19.8998 9.99837 19.8998Z",
    fill: "#495057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9515 15.832C3.92573 15.832 4.7155 15.0422 4.7155 14.068C4.7155 13.0937 3.92573 12.304 2.9515 12.304C1.97727 12.304 1.1875 13.0937 1.1875 14.068C1.1875 15.0422 1.97727 15.832 2.9515 15.832Z",
    fill: "#495057"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9515 7.69621C3.92573 7.69621 4.7155 6.90644 4.7155 5.93221C4.7155 4.95798 3.92573 4.16821 2.9515 4.16821C1.97727 4.16821 1.1875 4.95798 1.1875 5.93221C1.1875 6.90644 1.97727 7.69621 2.9515 7.69621Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql);
export default __webpack_public_path__ + "static/media/graphql.ce1728acbb98e3d8c9da6afed0a39275.svg";
export { ForwardRef as ReactComponent };